import axios from "axios";
import { environment } from "../../environment";
import { ICrmError } from "../crm/types";
import { VIEW_AS_PENDING_PREFIX, ViewAsState } from "./boot";

const crmUrl = `${environment.v2Url}/crm`;
const sessionUrl = `${environment.v2Url}/view-as`;

const toError = (err: any): ICrmError => {
    const status = err?.response?.status ?? 0;
    return {
        ok: false,
        status,
        message: String(err?.response?.data?.message ?? '').replace(/^\[[^\]]+\]\[[^\]]+\]:\s*/, '')
            || (status === 0 ? 'Could not reach Wallmates. Check your connection.' : 'Something went wrong.')
    } as ICrmError;
};

// #region openCustomerDashboard
/**
 * From the lead page: starts a view session and opens the customer's dashboard in a new tab.
 * The tab is opened before the request so popup blockers allow it; the session is handed over
 * through a one-time localStorage key the new tab removes as it reads it.
 */
export const openCustomerDashboard = async (
    repToken: string, leadId: number, mode: 'read' | 'edit', reason?: string
): Promise<true | ICrmError> => {
    const tab = window.open('', '_blank');
    try {
        const { data } = await axios.post<ViewAsState>(`${crmUrl}/leads/${leadId}/view-as`, { mode, reason }, {
            headers: { 'X-Wallmates-Auth': repToken }
        });
        const nonce = `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
        localStorage.setItem(VIEW_AS_PENDING_PREFIX + nonce, JSON.stringify(data));
        const url = `/view-as?k=${nonce}`;
        if (tab) tab.location.href = url;
        else window.open(url, '_blank');
        return true;
    } catch (err: any) {
        tab?.close();
        return toError(err);
    }
};

// #region endView
/** From inside the view tab: closes the session on the server. */
export const endView = async (viewToken: string): Promise<void> => {
    await axios.post(`${sessionUrl}/end`, {}, { headers: { 'X-Wallmates-Auth': viewToken } }).catch(() => undefined);
};

// #region logViewPage
/** From inside the view tab: records a page the rep opened. */
export const logViewPage = async (viewToken: string, path: string): Promise<void> => {
    await axios.post(`${sessionUrl}/page`, { path }, { headers: { 'X-Wallmates-Auth': viewToken } }).catch(() => undefined);
};
